import "@fontsource-variable/inter";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/700.css";
import "./styles.css";
import { route, start } from "./router.ts";
import { renderHome } from "./views/home.ts";
import { renderModule } from "./views/module.ts";

route(/^\/$/, (root) => renderHome(root));
route(/^\/modules\/([a-z0-9-]+)\/?$/, (root, id) => renderModule(root, id!));

start(document.getElementById("app")!);
